export type ListOptions = {
    playSoundWhenCheckedAndUncheked: boolean;
    groupByType: boolean;
    /**
     * checkedItemPosition replace the use of moveCheckedToEnd
     * @deprecated
     */
    moveCheckedToEnd: boolean;
    checkedItemsSection: boolean;
    checkedItemPosition: CheckedItemPosition,
    checkedItemsListSortOrder: CheckedItemsListSortOrder,
};

export enum CheckedItemPosition {
    InPlace = "InPlace",
    EndOfList = "EndOfList",
    CheckedItemsList = "CheckedItemsList",
}

export enum CheckedItemsListSortOrder {
    CheckedAt = "CheckedAt",
    Alpanumeric = "Alpanumeric"
}

export type ListsViewSettings = {
    sortOrderHistory: SortOrder[]
    showRemovedLists: boolean
};

export enum ListsViewSort {
    CreatedAt = "CreatedAt",
    ModifiedAt = "ModifiedAt",
    Name = "Name",
    Size = "Size",
    CheckedCount = "CheckedCount",
}

export type SortOrder = {
    sortBy: ListsViewSort;
}